import Heading from '@/components/pageheader_component.vue';
import axios from 'axios';
// import moment from 'moment';
import Popover from '@/components/popover_component.vue';
import LoaderPopover from '@/components/loaderpopover_component.vue';
import productImageCropModel from '@/components/product_image_crop_model.vue';
export default {
    name: 'productDetails',
    components:{
        Heading,LoaderPopover,productImageCropModel,Popover
    },
    data(){
        return {
            salons : [],
            salon_selected : '',
            product_status:false,
            show_make_default:false,
            scrollHeight : window.scrollY,
            product_name:'',
            sku_code:'',
            sku_code_validation:'',
            barcode:'',
            barcode_validation:'',
            description:'',
            quantity:50,
            product_compare_price:0,
            product_sale_price:0,
            product_internal_cost:0,
            service_image_crop_model:false,
            product_name_validation:'',
            quantity_validation:'',
            sale_price_validation:'',
            compare_price_validation:'',
            internal_price_validation:'',
            component_destroyed:false,
            popup_type:'delete_product',
            default_image_call_details:{},
            remove_popup:false,
            fake_serv_index:1,
            product_id:0,
            title:'',
            product_images_list:[],
            all_validations_passed:false,
            changes_happened:false,
            button_label:"Save",
            button2_label:'Cancel'
        }
    },
    computed:{
        product_images(){
            return this.$store.state.product_image_url_data;
        }
    },
    created(){
        this.getStore();
        this.$store.state.product_image_url_data = []
        if(this.$session.has('selected_product_id')){
            this.product_id = this.$session.get('selected_product_id');
            this.get_product_details();
        }
    },
    mounted() {
        document.getElementsByClassName('footer')[0].hidden = true;
        window.addEventListener("scroll", this.footerEnable);
        this.title = this.$session.get('product_title');
        if(this.title == 'New Product'){
            this.button_label = 'Save';
            this.button2_label = 'Cancel';
        }
        else {
            this.button2_label = 'Close';
            this.button_label = 'Update';}
        this.$session.remove("changes_happened");
    },
    beforeDestroy() {
        this.component_destroyed = true;
      },
    methods:{
        get_product_details(){
            this.$store.state.loader_popup = true;
            axios.post(this.$store.state.api +'v2/products/get_product_details_v2',{
                "product_id" :this.$session.get('selected_product_id')
            }).then(response => {
                this.salon_selected = response.data.result.store_id;
                this.product_name = response.data.result.product_name;
                this.sku_code = response.data.result.product_sku;
                this.barcode = response.data.result.product_barcode;
                this.description = response.data.result.product_description;
                this.quantity = response.data.result.product_quantity;
                this.product_compare_price =response.data.result.product_price;
                this.product_sale_price = response.data.result.product_sale_price;
                this.product_internal_cost = response.data.result.product_internal_cost;
                if(response.data.result.product_is_active)this.product_status = true
                else this.product_status = false
                this.$store.state.loader_popup = false;
                if(!this.product_compare_price) this.product_compare_price = 0;
                if(!this.product_sale_price) this.product_sale_price = 0;
                if(!this.product_internal_cost) this.product_internal_cost = 0;
                if(!this.sku_code) this.sku_code = '';
                if(!this.barcode) this.barcode = '';
                if(!this.description) this.description = '';
                if(this.$session.has('selected_product_id') && this.$session.get('product_title') == 'New Product')this.product_name = this.product_name+' ( Copy )';
                if(response.data.result.product_images.length > 0){
                    var image_obj = {};
                    var index = 0;
                    response.data.result.product_images.forEach(product_images => {
                        image_obj = {
                            index:index,
                            product_image_id:product_images.product_image_id,
                            image:product_images.product_image_url,
                            image_public_id:product_images.product_image_public_id,
                            thumbnail_public_id:product_images.product_thumbnail_public_id,
                            is_default:product_images.is_default,
                            show_is_default_button:false
                        }
                        this.$store.state.product_image_url_data.push(image_obj);
                        index++;
                    });
                }
            })
        },
        make_image_default(image_detials,index){
            this.default_image_call_details = image_detials;
            this.$store.state.product_image_url_data.forEach(product => {
                product.show_is_default_button = false
            });
            this.$store.state.product_image_url_data[index].show_is_default_button = true;
            
        },
        remove_image_default(index){
            this.$store.state.product_image_url_data[index].show_is_default_button = false;
        },
        async getStore(){
            await this.$store.dispatch('getStoreByOwnerId',[this.$store.state.api,this.$store.state.user_id]);

            if(Object.keys(this.$store.state.stores_data).length > 0){
                this.salons = this.$store.state.stores_data; 
            }

            this.salon_selected = this.$store.state.stores_data[0].store_id
        },
        quantity_validation_check(){
            this.changes_happened = true;
            this.$session.set("changes_happened",true);
            this.quantity_validation = '';
            if(!this.quantity) this.quantity = 0;
            if(this.quantity < 0){
                this.all_validations_passed = false;
                this.quantity_validation = 'Quantity should not be -ve'
            }
        },
        check_value_length(){
            this.changes_happened = true;
            this.$session.set("changes_happened",true);
            if(this.quantity > 9999){
                this.quantity = parseInt(this.quantity / 10);
                this.check_value_length();
            }
            if(this.product_sale_price > 9999){
                this.product_sale_price = parseFloat(this.product_sale_price/10)
                this.check_value_length();
            }
            if(this.product_compare_price > 9999){
                this.product_compare_price = parseFloat(this.product_compare_price/10)
                this.check_value_length();
            }
            if(this.product_internal_cost > 9999){
                this.product_internal_cost = parseFloat(this.product_internal_cost/10)
                this.check_value_length();
            }
        },
        price_validations(){
            this.$session.set("changes_happened",true);
            this.changes_happened = true;
            this.sale_price_validation = '';
            this.compare_price_validation = '';
            this.internal_price_validation = '';
            if(!this.product_compare_price) this.product_compare_price = 0;
            if(!this.product_sale_price) this.product_sale_price = 0;
            if(!this.product_internal_cost) this.product_internal_cost = 0;
            this.product_compare_price = parseFloat(this.product_compare_price);
            this.product_sale_price = parseFloat(this.product_sale_price);
            this.product_internal_cost = parseFloat(this.product_internal_cost);
            if((this.product_compare_price <= this.product_sale_price) && this.product_compare_price > 0){
                this.all_validations_passed = false;
                this.compare_price_validation = 'Compare price must be grater than sale price';
            }
            if(this.product_sale_price < 0){
                this.all_validations_passed = false;
                this.sale_price_validation = 'Sale price should be positive number'
            }
            if(this.product_compare_price < 0){
                this.all_validations_passed = false;
                this.compare_price_validation = 'Compare price should be positive number'
            }
            if(this.product_internal_cost < 0){
                this.all_validations_passed = false;
                this.internal_price_validation = 'Internal price should be positive number'
            }
        },
        product_name_validation_check(){
            this.changes_happened = true;
            this.$session.set("changes_happened",true);
            this.product_name = this.product_name.replace(/  +/g, ' ')
            this.product_name = this.product_name.trim();
            this.product_name_validation = ''
            if(this.product_name.length == 0){
                this.all_validations_passed = false 
                this.product_name_validation = 'Please fill the product name'
            }
            else if((/<img.*|<script.*|<style.*|<embeded.*/ig).test(this.product_name)){
                this.all_validations_passed = false 
                this.product_name_validation = 'Enter a valid product name'
            }
        },
        sku_code_validation_check(){
            this.changes_happened = true;
            if(!this.sku_code)this.sku_code = '';
            this.$session.set("changes_happened",true);
            this.sku_code = this.sku_code.replace(/  +/g, ' ')
            this.sku_code = this.sku_code.trim();
            this.sku_code_validation = ''
            if(this.sku_code.includes("'") || this.sku_code.includes('"')){
                this.all_validations_passed = false 
                this.sku_code_validation = 'Enter a valid sku code'
            }
            else if((/<img.*|<script.*|<style.*|<embeded.*/ig).test(this.sku_code)){
                this.all_validations_passed = false 
                this.sku_code_validation = 'Enter a valid sku code'
            }
        },
        barcode_validation_check(){
            this.changes_happened = true;
            if(!this.barcode)this.barcode = '';
            this.$session.set("changes_happened",true);
            this.barcode = this.barcode.replace(/  +/g, ' ')
            this.barcode = this.barcode.trim();
            this.barcode_validation = ''
            if(this.barcode.includes("'") || this.barcode.includes('"')){
                this.all_validations_passed = false 
                this.barcode_validation = 'Enter a valid barcode'
            }
            else if((/<img.*|<script.*|<style.*|<embeded.*/ig).test(this.barcode)){
                this.all_validations_passed = false 
                this.barcode_validation = 'Enter a valid sku code'
            }
        },
        openImageModel(show_upload){
            this.show_upload_picture = show_upload;
            this.service_image_crop_model   = true;
        },
        set_default_image(){
            this.changes_happened = true;
            this.$session.set("changes_happened",true);
            axios.post(this.$store.state.api +'v2/products/make_image_default_v2',{
                "product_id":this.product_id,
                "product_image_id" : this.default_image_call_details.product_image_id,
                "updated_by" : this.$store.state.user_id
            }).then(response =>{
                if(response.data.status == 200){
                    this.$store.state.product_image_url_data.forEach(product => {
                        if(product.is_default == 1)product.is_default = 0
                        product.show_is_default_button=false
                    });
                    this.$store.state.product_image_url_data[this.default_image_call_details.index].is_default = 1;
                }
            })
        },
        validation_check(){
            this.all_validations_passed = true;
            this.price_validations()
            this.product_name_validation_check()
            this.sku_code_validation_check();
            this.quantity_validation_check()
            this.barcode_validation_check()
            this.$store.state.product_image_url_data.forEach(product => {
                this.product_images_list.push(product.image)
            });
            if(this.all_validations_passed) this.add_product()
        },
        add_product(){
            if(!this.sku_code)this.sku_code = '';
            if(!this.barcode)this.barcode = '';
            if(!this.description)this.description = '';
            if(!this.product_compare_price) this.product_compare_price = 0;
            if(!this.product_sale_price) this.product_sale_price = 0;
            if(!this.product_internal_cost) this.product_internal_cost = 0;
            this.$store.state.loader_popup = true;
            if(this.$session.get('product_title') == 'Edit Product'){

                axios.post(this.$store.state.api +'v2/products/save_product_v2',{
                    "product_id" : this.$session.get('selected_product_id'),
                    "store_id" :this.salon_selected,
                    "product_name": this.product_name,
                    "product_sku" : this.sku_code,
                    "product_barcode" : this.barcode,
                    "product_description" : this.description,
                    "product_quantity" : this.quantity,
                    "product_price" : this.product_compare_price,
                    "product_sale_price": this.product_sale_price,
                    "product_internal_cost" : this.product_internal_cost,
                    "product_is_active" : this.product_status,
                    "product_created_by": this.$store.state.user_id,
                    "update_flag" : 1
                }).then(response =>{

                if(response.data.status == 200){
                    this.$session.set('show_toast_product',true);
                    this.$session.set('toast_title','Product Updated Successfully!');
                    this.$session.set('toast_message',`${this.product_name} has been updated successfully.`);
                    
                    this.$router.push('/inventory');
                }
                this.$store.state.loader_popup = false;

                })
            }
            else{
                axios.post(this.$store.state.api +'v2/products/save_product_v2',{
                    "store_id" :this.salon_selected,
                    "product_name": this.product_name,
                    "product_sku" : this.sku_code,
                    "product_barcode" : this.barcode,
                    "product_description" : this.description,
                    "product_quantity" : this.quantity,
                    "product_price" : this.product_compare_price,
                    "product_sale_price": this.product_sale_price,
                    "product_internal_cost" : this.product_internal_cost,
                    "product_is_active" : this.product_status,
                    "product_created_by": this.$store.state.user_id,
                    "product_images" : this.product_images_list
                }).then(response =>{
                if(response.data.status == 200){
                    if(this.$session.get('came_from') == 'inventory'){
                        this.$router.push('/inventory');
                        this.$session.set('show_toast_product',true);
                        this.$session.set('toast_title','Product Created Successfully!');
                        this.$session.set('toast_message',`${this.product_name} has been created successfully.`)
                    }
                    else if(this.$session.get('came_from') == 'newbooking'){

                        this.$store.state.selected_products.push({
                            product_id:response.data.result.product_id,
                            product_name:this.product_name,
                            product_sku:this.sku_code,
                            product_barcode:this.barcode,
                            product_default_image:{
                                product_image_url:'',
                                product_thumbnail_url:''
                            },
                            selected_quantity:1,
                            product_quantity:this.quantity,
                            product_sale_price:this.product_sale_price, 
                            product_price:this.product_compare_price
                        })
                        this.$router.push('/newbooking')
                    }
                
                }
                this.$store.state.loader_popup = false;
                })
            }
        },
        footerEnable() {
            this.scrollHeight = window.scrollY;
            if(!this.component_destroyed){
                if(this.scrollHeight > 75){
                    document.getElementsByClassName('footer')[0].hidden = false;
                }
                else{
                    document.getElementsByClassName('footer')[0].hidden = true;
                }
            }
        },
        move_to_inventory(){
            this.popup_type = 'Discard_Changes';
            if(this.changes_happened == true) this.remove_popup = true;
            else {
            if(this.$session.get('came_from') == 'inventory'){
                this.$router.push('/inventory');
            }else this.$router.push('/newbooking');
        
        }
        },
        delete_product_popup(){
            this.popup_type = 'delete_product';
            this.remove_popup = true;
        },
        remove_popup_card(){
            this.remove_popup = false;
        },
        action_status(status){
            if(status == 'Delete')this.delete_product();
            else {
                if(this.$session.get('came_from') == 'inventory'){
                    this.$router.push('/inventory');
                }else this.$router.push('/newbooking');
            }

        },
        delete_product(){
            axios.post(this.$store.state.api +'v2/products/delete_product_v2',{
                "store_id" :this.salon_selected,
                "product_id":this.$session.get('selected_product_id')
            }).then(response => {
                if(response.data.status == 200){
                    this.remove_popup = false;
                    this.$router.push('/inventory')
                }
            })
        },
       
    }
    
}